import { render, staticRenderFns } from "./SelectInput.vue?vue&type=template&id=04fcb8de&scoped=true&"
import script from "./SelectInput.vue?vue&type=script&lang=js&"
export * from "./SelectInput.vue?vue&type=script&lang=js&"
import style0 from "./SelectInput.vue?vue&type=style&index=0&id=04fcb8de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04fcb8de",
  null
  
)

export default component.exports